<div class="row">
    <div class="col-md-6">
        <app-treeview></app-treeview>
    </div>
    <div class="col-md-6">
        <app-backup></app-backup>
    </div>
</div>